export const darkTheme = {
  background: "#0F1115",
  text: "#F5F5F5",
  primary: "#fff",
  orange: "#ff6b00", // neon cyan
  secondary: "rgba(255,255,255,.5)", // neon pink
  glass: "rgba(255, 255, 255, 0.05)",
};

export const gradients = {
  heroBackground: "linear-gradient(-45deg, #0a0a0a, #1a1a1a, #0f0f0f, #1c1c1c)",
};
